module.exports = __webpack_public_path__ + "media/public/img/getyourguide-favicon-01-101506c29f7df6877f229975b89617d5.svg";